module.exports = __webpack_public_path__ + "img/case1-8.acf4a400.jpg";